import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  () => ({
    root: {
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      background: "black",
      overflow: "hidden",
      position: "relative",
    },
    video: {
      width: "100%",
      height: "100%",
    },
    aspectRatio: {
      aspectRatio: (props) => props.aspectRatio,
    },
  }),
  { name: "VideoJsPlayer" },
);
